import { Divider, Header, List, Message, Segment } from "semantic-ui-react";
import { BackgroundContainer } from "../components/BackgroundContainer";

export default function HelpNotificationsPage() {
    return (
        <BackgroundContainer>
            <div className="App" style={{ padding: "2rem" }}>
                <Message>
                    <Header as="h2">Push notifikácie - Android</Header>
                    <p>
                        Push notifikácie ti umožnia dostávať okamžité upozornenia priamo do
                        tvojho telefónu. Postupuj podľa nasledujúcich krokov:
                    </p>

                    <Divider />

                    <Segment>
                        <Header as="h3">1. Skontroluj nastavenia prehliadača</Header>
                        <List bulleted>
                            <List.Item>
                                Otvor aplikáciu v prehliadači (Chrome, Edge alebo iný podporujúci
                                notifikácie).
                            </List.Item>
                            <List.Item>
                                Klikni na ikonu 🔒 v hornej časti adresného riadku.
                            </List.Item>
                            <List.Item>
                                Skontroluj položku <strong>Notifikácie</strong> a nastav ju na{" "}
                                <strong>Povoliť</strong>.
                            </List.Item>
                            <List.Item>
                                Ak je nastavené <em>Blokované</em>, zmeň na <em>Povoliť</em>.
                            </List.Item>
                        </List>
                    </Segment>

                    <Segment>
                        <Header as="h3">2. Aktivuj notifikácie v aplikácii</Header>
                        <List bulleted>
                            <List.Item>Choď do sekcie <strong>Nastavenia</strong>.</List.Item>
                            <List.Item>Klikni na tlačidlo <strong>AKTIVOVAŤ NOTIFIKÁCIE</strong>.</List.Item>
                            <List.Item>
                                Zobrazí sa systémový popup – vyber <strong>Povoliť</strong>.
                            </List.Item>
                        </List>
                    </Segment>

                    <Segment>
                        <Header as="h3">3. Skontroluj stav</Header>
                        <List bulleted>
                            <List.Item>
                                Po povolení sa v nastaveniach zobrazí <strong>Notifikácie: povolené</strong>.
                            </List.Item>
                            <List.Item>
                                Ak chceš notifikácie vypnúť, klikni na <strong>DEAKTIVOVAŤ NOTIFIKÁCIE</strong>.
                            </List.Item>
                            <List.Item>
                                Stav sa aktualizuje na <strong>Notifikácie: nepovolené</strong>.
                            </List.Item>
                        </List>
                    </Segment>

                    <Segment>
                        <Header as="h3">ℹ️ Tip</Header>
                        <List bulleted>
                            <List.Item>
                                Ak si notifikácie zamietol, môžeš ich znova povoliť cez nastavenia
                                prehliadača → Povolenia webu → Notifikácie.
                            </List.Item>
                            <List.Item>
                                Pre najlepšiu skúsenosť odporúčame použiť najnovšiu verziu Google
                                Chrome na Androide.
                            </List.Item>
                        </List>
                    </Segment>
                </Message>
            </div>
        </BackgroundContainer>
    );
}